var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("page not found")]),_c('button',{on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("go home")])])}
var staticRenderFns = []

export { render, staticRenderFns }